export const ADD_TEMPLATE_MUTATION = `
mutation AddTemplate($name: String!, $characteristicIds: [ID!]!) { 
\taddTemplate(name: $name, characteristicIds: $characteristicIds)
}
`